// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3uLsBt2GBmaA-vVMVtDhDa"};